/**
   * @ngdoc directive
   * @name adjust.directive:status
   * @scope
   * @restrict E
   *
   * @description
   * Save status modal
   *
   * @param {Object} trace trace to show in modal
   * @param {Function} onClose on close callback
   *
   */
function status() {
  'ngInject';
  return {
    restrict: 'E',
    scope: {},
    controller: 'StatusController',
    controllerAs: 'vm',
    bindToController: {
      trace: '=',
      onClose: '&',
      parent: '@'
    }
  };
}

/**
   * @ngdoc controller
   * @name adjust.controller:StatusController
   *
   * @description
   * All the functionality of the {@link adjust.directive:status status} directive
   *
   */
function StatusController($scope, Modal, $timeout, Helper) {
  'ngInject';
  var vm = this;

  var _tid;
  var _parent = vm.parent || '#sidebar-view';

  $scope.$watch('vm.trace.status', _handleStatusChange);
  $scope.$on('$destroy', _destroy);

  /**
   * @ngdoc method
   * @name _handleStatusChange
   * @methodOf adjust.controller:StatusController
   *
   * @description
   * Callback on status change
   *
   * @param {string} n new value
   * @param {string} o old value
   * @private
   */
  function _handleStatusChange(n, o) {
    if (n !== o && n) {
      _initModal();
    }
  }

  /**
   * @ngdoc method
   * @name _initModal
   * @methodOf adjust.controller:StatusController
   *
   * @description
   * Initiate modal when status is changed
   *
   * @private
   */
  function _initModal() {

    _destroy();

    var options = {
      parent: _parent,
      tpl: require('./status.html'),
      title: '',
      align: 'center',
      initialModel: {
        message: vm.trace.message,
        trace: vm.trace
      },
      hideCancel: true,
      classes: [vm.trace.status, 'status', 'helper-msg']
    };

    if (vm.trace.status === 'success') {
      options.hideConfirm = true;
    }

    Modal.init(options)
      .result.then(function() {
        vm.trace = {};
      });

    if (vm.trace.status === 'error') { return; }

    _tid = $timeout(function() {

      Modal.getInstance().close();

      if (angular.isFunction(vm.onClose)) { vm.onClose(); }

    }, 2000);

  }

  /**
   * @ngdoc method
   * @name _destroy
   * @methodOf adjust.controller:StatusController
   *
   * @description
   * Destroy timeout and modal instance if exists
   *
   * @private
   */
  function _destroy() {

    if (!vm.trace) {
      return;
    }

    Helper.destroyTid(_tid);

    var modalInstance = Modal.getInstance();

    if (modalInstance) {
      modalInstance.cancel();
    }

  }
}

export { StatusController, status };
